import type { RouteObject } from "react-router-dom";
import { Configuration } from "./Configuration";
import { MyInfo } from "./MyInfo/MyInfo";

// `Configuration` gates the whole subtree on the `ddc-configuration-access` LD flag.
export const PagesConfigurationUiRoutes: RouteObject[] = [
  {
    path: "configuration",
    element: <Configuration />,
    children: [
      {
        index: true,
        element: <MyInfo />
      },
      {
        path: "myinfo",
        element: <MyInfo />
      }
    ]
  }
];
